module.exports = __webpack_public_path__ + "img/ipad-cn-4.93f483a.jpg";